<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-02-22 16:31:35
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-06-11 11:12:03
 * @FilePath: \newsmallmap\src\views\Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="content">
    <div class="Loginlogo">
      <!-- <img src="../../src/assets/images/czlogo.png" alt /> -->
      <div class="demoLogo">新疆阿克苏地区雷电监测预警平台</div>
    </div>
    <el-card class="box-card" :style="{ height: showRegion ? '560px' : '500px' }">
      <div class="title">
        <p>系统登录</p>
      </div>
      <el-divider></el-divider>
      <div class="bodyer">
        <span>账号：</span>
        <el-input
          v-model="username"
          type="text"
          suffix-icon="el-icon-user-solid"
          placeholder="请输入账号"
          style="width: 300px; margin-top: 20px;"
          @input="onUsernameInput"
        ></el-input>
        <br />
        <span>密码：</span>
        <el-input
          v-model="password"
          type="password"
          suffix-icon="el-icon-key"
          placeholder="请输入密码"
          style="width: 300px; margin-top: 20px;"
        ></el-input>
        <br />
        <div v-if="showRegion">
        <span>区域：</span>
        <el-select
          v-model="selectedRegion"
          placeholder="请选择区域"
          style="width: 300px; margin-top: 20px;"
        >
          <el-option
            v-for="item in regionList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        </div>
        
      </div>
      <div class="footer" style=" margin-top: 40px;">
        <el-button
          type="primary"
          style="width: 300px; height: 50px; float: right;"
          @click="submit"
        >登录</el-button>
      </div>
      <div class="forget">
        <p style="font-size: 14px;margin-top: 150px;padding-left: 150px; color: #409EFF;">忘记密码？</p>
      </div>
    </el-card>
    <div class="maplogo">
      <img src="../../assets/maplogo.png" alt />
    </div>
  </div>
</template>

<script >
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      username: "",
      password: "",
      selectedRegion: "",
      regionList: [
        { name: '阿克苏气象局', code: '1' },
        { name: '拜城工业园区', code: '2' },
        { name: '温宿产业园区', code: '3' },
        { name: '沙雅工业园区', code: '4' },
        { name: '新和县工业园区（西区）', code: '5' },
      ],
      superAdminList: [],
      showRegion: false
    };
  },
  created() {
    this.$axios({
      method: "get",
      url: `${this.$url2}/user/getAllSuperAdmin`
    }).then((res) => {
      console.log("getAllSuperAdmin返回结果:", res.data);
      if (res.data.success) {
        this.superAdminList = res.data.data;
      }
    });
  },
  methods: {
    onUsernameInput(val) {
      this.showRegion = this.superAdminList.some(
        (item) => item.phoneNum === val
      );
      if (!this.showRegion) {
        this.selectedRegion = "";
      }
    },
    submit() {
      if (!this.selectedRegion&&this.showRegion) {
        this.$message({ message: '请选择区域', type: 'warning' });
        return;
      }
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${this.$url2}/user/login?username=${this.username}&password=${this.password}&regionCode=${this.selectedRegion}`
      }).then((res)=>{
        console.log(res.data);
        if(res.data.code=='500'){
           this.$message({
          message: res.data.message,
          type: 'warning'
        });
        }else{
           this.$message({
          message: '登录成功',
          type: 'success '

          
        });
      
        
        Cookies.set('roundMap',JSON.stringify([[res.data.data.top,res.data.data.left],[res.data.data.bottom,res.data.data.right]])  )
        Cookies.set('factoryid',res.data.data.factory )
        Cookies.set('regionpath', res.data.data.regionpath)
        Cookies.set('areaName', res.data.data.areaName)
           Cookies.set('areaCode', res.data.data.areaCode);
        Cookies.set('regionpath_out', res.data.data.regionpath_out)
        Cookies.set('role', res.data.data.role)
        this.$router.push('/home')
        }
        
        
      })
    }
  }
};
</script>

<style scoped>
body {
  padding: 0;
  margin: 0;
}
.content {
  position: fixed;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url(../../assets/banner.png);
}
.Loginlogo {
  position: absolute;
  left: 10%;
  top: 10vh;
  z-index: 2;
}
.Loginlogo img {
  width: auto;
  max-width: 100%;
}
.maplogo {
  position: absolute;
  left: 45%;
  top: 18vh;
}
.maplogo img {
  width: auto;
  max-width: 100%;
}
.box-card {
  width: 400px;
  /* height 由动态 style 控制 */
  display: flex;
  justify-content: center;
  position: absolute;
  left: 10%;
  top: 30vh;
  z-index: 3;
}
.box-card p {
  font-weight: 400;
  font-size: 28px;
  margin-left: 35%;
}
.box-card .bodyer .el-input__inner {
  height: 55px !important;
  background-color: white !important;
  color: #000000 !important;
}
.demoLogo {
  font-size: 55px;
  color: white;
  font-weight: 700;
}
/* .el-input__inner {
  background-color: white !important;
  color: #000000 !important;
} */
</style>